import style from './Iris.module.scss'

const Iris = () => {

    return(
        <div className={style.iris_wipe} />
    )
}

export default Iris